import CreatorDeletePostModal from "./CreatorDeletePostModal";

export default CreatorDeletePostModal